module.exports = __webpack_public_path__ + "static/img/ls19.14f30e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark2/ls19.png
// module id = 9fpC
// module chunks = 12